// extracted by mini-css-extract-plugin
module.exports = {"headerCardTitle":"CourseData_headerCardTitle__1ip6m","colTitle":"CourseData_colTitle__Zw0HI"};